import React from 'react';

const PlusIconLarge = () => (
  <div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="10.9092" width="24" height="2.90909" rx="1.45455" fill="#397EF3" />
      <rect
        x="10.1819"
        y="24"
        width="24"
        height="2.90909"
        rx="1.45455"
        transform="rotate(-90 10.1819 24)"
        fill="#397EF3"
      />
    </svg>
  </div>
);

export default PlusIconLarge;
